var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
export default function StripBioUpdated(props) {
    var fields = props.fields, children = props.children;
    var TitleTag = (fields.titleTag || 'h1');
    return (React.createElement("div", __assign({ className: "strip spa-strip-bio "
            + fields.backgroundColor
            + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
            + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "")
            + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
            + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "") }, (fields.jumplinkLabel ? { id: fields.jumplinkLabel.replace(/ /g, '') } : {})),
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12 col-lg-4 mb-4 info-top" },
                    fields.displayTitle &&
                        React.createElement(TitleTag, { className: "title " + fields.titleStyle, itemProp: "name", dangerouslySetInnerHTML: { __html: fields.displayTitle } }) || null,
                    React.createElement("div", { className: "abstract", dangerouslySetInnerHTML: { __html: fields.description } }))),
            React.createElement("div", { className: "row" }, children &&
                children.map(function (child) { return (React.createElement(BioCard, { key: child.id, child: child })); })))));
}
function BioCard(_a) {
    var child = _a.child;
    var _b = useState(false), isExpanded = _b[0], setIsExpanded = _b[1];
    var toggleModal = function () { return setIsExpanded(!isExpanded); };
    var handleKeyDown = function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleModal();
        }
    };
    return (React.createElement("div", { className: "col-12 col-sm-6 col-lg-4 mb-4" },
        React.createElement("div", { className: "card-bio" },
            React.createElement("div", { className: "img-container", role: "button", tabIndex: 0, onClick: toggleModal, onKeyDown: handleKeyDown },
                React.createElement("img", { src: child.fields.image, alt: child.fields.image_description || '', title: child.fields.image_title || '', className: "card-img-top", style: { cursor: 'pointer' } }),
                React.createElement("div", { className: "overlay" },
                    React.createElement("div", { className: "btn-pill" }, "Expand"))),
            React.createElement("div", { className: "card-body h6" },
                React.createElement("div", { className: "card-title" },
                    React.createElement("span", { className: "name-link", role: "button", tabIndex: 0, onClick: toggleModal, onKeyDown: handleKeyDown },
                        child.fields.firstName,
                        " ",
                        child.fields.lastName)),
                React.createElement("div", { className: "card-subtitle mb-2" }, child.fields.function),
                child.fields.linkedinPageLink &&
                    React.createElement("div", { className: "card-linked-in" },
                        React.createElement("a", { className: 'btn btn-link', href: child.fields.linkedinPageLink, target: '_blank', title: 'LinkedIn' }, " LINKEDIN ")))),
        React.createElement(Modal, { isOpen: isExpanded, className: "bio-modal", toggle: toggleModal },
            React.createElement(ModalHeader, { toggle: toggleModal }),
            React.createElement(ModalBody, null,
                React.createElement("div", { className: "bio-info" },
                    React.createElement("div", { className: "img-container" },
                        React.createElement("img", { src: child.fields.image, alt: child.fields.image_description || '', title: child.fields.image_title || '', className: "img-fluid" })),
                    React.createElement("div", { className: "right-side" },
                        React.createElement("div", { className: "h6 name" },
                            child.fields.firstName,
                            " ",
                            child.fields.lastName),
                        React.createElement("div", { className: "bio-details" },
                            React.createElement("div", null, child.fields.function),
                            React.createElement("div", { className: "abstract", dangerouslySetInnerHTML: { __html: child.fields.description } })),
                        child.fields.linkedinPageLink && (React.createElement("div", { className: "social" },
                            React.createElement("a", { className: "btn btn-link", href: child.fields.linkedinPageLink, target: "_blank", rel: "noopener noreferrer" }, "LinkedIn")))))))));
}
